import axios from 'axios';
import config from '../config';
import { getBearerToken } from '../util/cookie';

export const sendOnboardingWelcomeEmail = () => async (dispatch, getState, sdk) => {
  return axios.post(
    `${config.coachSaaSService}marketing/onboarding-welcome`,
    {},
    {
      headers: {
        'content-type': 'application/json',
        Authorization: await getBearerToken(sdk),
      },
    }
  );
};
